var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLowers = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1499 3.3335H5.22492C4.63523 3.3335 4.1394 3.3335 3.73476 3.36626C3.30976 3.40167 2.90778 3.47605 2.52528 3.67173C1.94211 3.96864 1.46789 4.44254 1.1706 5.02553C0.975804 5.40803 0.900544 5.81089 0.866012 6.23501C0.833252 6.64053 0.833252 7.13548 0.833252 7.72516V13.1085C0.833252 13.6982 0.833252 14.194 0.866012 14.5987C0.901429 15.0237 0.975804 15.4256 1.1706 15.8081C1.46774 16.3914 1.94197 16.8657 2.52528 17.1628C2.90778 17.3576 3.31065 17.4329 3.73476 17.4674C4.1394 17.5002 4.63523 17.5002 5.22492 17.5002H14.1499C14.7396 17.5002 15.2354 17.5002 15.6401 17.4674C16.0651 17.432 16.4671 17.3567 16.8496 17.1619C17.4327 16.865 17.9069 16.3911 18.2042 15.8081C18.399 15.4256 18.4743 15.0228 18.5088 14.5987C18.5416 14.194 18.5416 13.6982 18.5416 13.1085V7.72516C18.5416 7.13548 18.5416 6.63964 18.5088 6.23501C18.4734 5.81001 18.3981 5.40803 18.2034 5.02553C17.9064 4.44235 17.4325 3.96813 16.8496 3.67084C16.4671 3.47605 16.0642 3.40079 15.6401 3.36626C15.2354 3.3335 14.7396 3.3335 14.1499 3.3335Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80867 11.6665C10.384 11.6665 10.8503 12.1329 10.8503 12.7082C10.8503 13.2835 10.384 13.7498 9.80867 13.7498H0.833252V11.6665H9.80867Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLowers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-lowers.14f0940c9ac6d010295c5595e3111254.svg";